import { useState, useEffect } from "react"

const useUserAgent = () => {
  const [isSearchBot, setSearchBot] = useState(false)

  useEffect(() => {
    const userAgent = navigator.userAgent?.toLowerCase()
    const botUserAgents = ["googlebot", "bingbot", "linkedinbot", "mediapartners-google"]

    setSearchBot(Boolean(userAgent) && botUserAgents.some((bot) => userAgent.includes(bot)))
  }, [])

  return isSearchBot
}

export default useUserAgent
